var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"grid-list-md":""}},[_c('span',[_vm._v("This is settings page.")])])}
var staticRenderFns = []

export { render, staticRenderFns }